import React from 'react'

class LineDiv extends React.Component {
	render () {
		return (
			<div className="donate_linner_div center-block" style={{ maxWidth: 400, marginRight: 'auto', marginLeft: 'auto' }} ></div>
		);
	}
}

export default LineDiv
